module.exports = __webpack_public_path__ + "static/img/teacher-code.134d9b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/4.0.2/teacher-code.png
// module id = kY8Y
// module chunks = 43